import SharedHeader from '@/components/share/header'
import SharedFooter from '@/components/share/footer'

export default {
  name: 'plan',
  components: {
    SharedHeader,
    SharedFooter
  },
  computed: {
    isSignedIn () {
      return this.$store.getters.isSignedIn
    },
    env () {
      return this.$store.getters.env
    },
    api () {
      return this.$store.getters.api
    },
    user () {
      return this.$store.getters.user
    },
    contactStatus () {
      return this.contact.name &&
             this.contact.phone &&
             this.contact.name &&
             this.contact.company &&
             this.contact.department &&
             this.contact.position &&
             this.contact.objective.length
    }
  },
  data () {
    return {
      loading: true,
      duration: {
        list: [
          // {value: 1, text: '1ヶ月'},
          {value: 2, text: '3ヶ月'},
          {value: 3, text: '6ヶ月'},
          {value: 4, text: '12ヶ月'}
        ],
        selected: {value: 4, text: '12ヶ月'}
      },
      plan: {
        list: [
          {value: 1, detail: {title: 'FREE', description: '少人数のインターン採用をお考えのチーム向けのフリープラン'}, price: {1: '無料', 2: '無料', 3: '無料', 4: '無料'}, btn: '今すぐはじめる', variant: 'secondary'},
          {value: 2, detail: {title: 'BASIC', description: '新卒・インターン採用をお考えの成長企業向けのベーシックプラン'}, price: {1: 10, 2: 20, 3: 15, 4: 10}, btn: '利用申請する', variant: 'success'},
          {value: 3, detail: {title: 'PRO', description: '新卒、インターン採用に力を入れている企業向けのプロプラン'}, price: {1: 20, 2: 40, 3: 30, 4: 20}, btn: '利用申請する', variant: 'primary'},
          {value: 4, detail: {title: 'ENTERPRISE', description: '高度な新卒、インターン採用支援機能を備えた包括的ソリューション'}, price: {1: 'お問い合わせ', 2: 'お問い合わせ', 3: 'お問い合わせ', 4: 'お問い合わせ'}, btn: 'お問い合わせ', variant: 'info'}
        ],
        selected: {detail: {}}
      },
      power: [
        {text: 'スワイプカードの作成・掲載', plan: [1, 2, 3, 4]},
        {text: '月間100SWまでの配信', plan: [1]},
        {text: '月間500SWまでの配信', detail: ['セグメント配信'], plan: [2]},
        {text: '月間1000SWまでの配信', detail: ['セグメント配信'], plan: [3, 4]},
        {text: '配信結果の閲覧', detail: ['配信数の確認', '興味ありした学生リストの閲覧', 'アンケート結果の閲覧'], plan: [1]},
        {text: '配信結果の閲覧', detail: ['配信数の確認', '興味ありした学生リストの閲覧', 'アンケート結果の閲覧', 'アンケート統計の閲覧'], plan: [2, 3, 4]},
        {text: '学生とのコンタクト', detail: ['学生プロフィールの閲覧', 'メッセージ機能', 'メッセージの自動送信'], plan: [2, 3, 4]},
        {text: 'カスタマーサポート', detail: ['3営業日以内', 'チャットサポート', 'メールサポート'], plan: [2, 3, 4]},
        {text: '分析レポート', detail: ['3ヶ月に1度'], plan: [2, 3]},
        {text: '分析レポート', detail: ['1ヶ月に1度'], plan: [4]},
        {text: '運用代行', plan: [4]}
      ],
      modal: {
        contact: false,
        apply: false,
        alert: false
      },
      dismissSecs: 2,
      dismissCountDown: 0,
      showDismissibleAlert: false,
      contact: {
        email: '',
        phone: '',
        name: '',
        company: '',
        department: '',
        position: '',
        objective: []
      },
      objectiveOptions: [
        { value: 1, text: '新卒採用の一環として' },
        { value: 2, text: '学生への認知拡大' },
        { value: 3, text: '長期インターン採用' },
        { value: 4, text: '短期インターン採用' },
        { value: 5, text: 'イベント等への誘致' }
      ],
      question: [
        {q: 'SWとはなんですか？', a: 'SWとは配信したスワイプカードに対して学生が「興味あり」「興味なし」のスワイプで反応することで、1SW = 1学生の1スワイプ となります。'},
        {q: '成功報酬はかかりますか？', a: '一切かかりません。何名採用されても成果報酬はいただきません。'},
        {q: 'メッセージは何通まで送信できますか？', a: '通数制限はございません。何通でも送信してください'},
        {q: 'アンケート結果の閲覧とはなんですか？', a: '学生が「興味なし」をした際に、アンケートを実施することができます。そのアンケートで収集した結果を閲覧することができます。'},
        {q: 'アンケート統計の閲覧とはなんですか？', a: '学生の「興味あり」「興味なし」の結果、学生の属性別で閲覧することができます。属性は、学校・学んでいる学問・希望職種などがあります。'},
        {q: '途中でプランを変更することはできますか？', a: 'できません。既にご利用しているプランの全契約期間のご料金をお支払いいただき、再契約の必要がございます。SW数に余裕をもったプランをお薦めします。'},
        {q: 'SWを全て使ってしまった場合は、スワイプカードの配信はできないのですか？', a: '追加でSWを購入することができます。カスタマーサポートへお問い合わせください。'}
      ],
      newAlertFlag: true
    }
  },
  mounted () {
    this.loading = false
  },
  methods: {
    openModal (item) {
      this.plan.selected = item
      if (item.value === 1) {
        let routeData = this.$router.resolve({path: '/signup'})
        window.open(routeData.href, '_blank')
      } else {
        if (this.isSignedIn) {
          this.modal.apply = true
        } else {
          this.modal.contact = true
        }
      }
    },
    handleOk (evt) {
      evt.preventDefault()

      let additionalParams = {
        queryParams: {
          type: this.isSignedIn ? 'apply' : 'contact'
        }
      }

      let body = {
        duration: this.duration.selected,
        plan: this.plan.selected
      }

      if (this.isSignedIn) {
        body.comment = `${this.plan.selected.detail.title}プランの${this.duration.selected.text}の利用申請`
      } else {
        if (!this.contactStatus) {
          this.modal.alert = true
          this.showAlert()
          return
        } else {
          this.modal.alert = false
          body.comment = `${this.plan.selected.detail.title}プランの問い合わせ`
          body.contact = Object.assign({}, this.contact)

          body.contact.objective = []
          for (let item of this.objectiveOptions) {
            if (this.contact.objective.indexOf(item.value) !== -1) body.contact.objective.push(item.text)
          }
        }
      }

      this.$store.commit('onMovingChanged', true)

      this.$apig.patch(this.api.PLAN, {}, additionalParams, body, !this.isSignedIn)
        .then(response => {
          this.showAlert()
          this.modal.apply = false
          this.modal.contact = false
          this.$store.commit('onMovingChanged', false)
        })
    },
    countDownChanged (dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },
    showAlert () {
      this.dismissCountDown = this.dismissSecs
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/plan/plan.js